export default __webpack_public_path__ + "static/media/HQicon.9e6c548a.ico";